import { render } from "./IPCard.vue?vue&type=template&id=fcbb48da"
import script from "./IPCard.vue?vue&type=script&lang=js"
export * from "./IPCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__